<template>
  <base-modal>
    <z-form ref="form">
      <p>{{ $t('shared.component.modal.confirmation.recording') }}</p>
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('shared.component.filter.period') }}
        </div>
        <div class="col-10 pl-0 pr-25">
          <z-form-input class="filter__item__body">
            <date-range-picker
              v-model="form.date"
              :clearable="false"
              :options="options"
              :export="true"
            />
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>
    <template #footer-cancel="{ close }">
      <i-button size="large" @click="close()" ref="close">
        {{ $t('shared.component.button.cancel') }}
      </i-button>
    </template>
    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      @click="exportRequest"
    >
      {{ $t('shared.component.export_report.export_records') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import TrunksInputSelectTrunk from '@voice/components/trunks-input-select-trunk';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { ExportService } from '@pbx/services/ExportService';

  export default {
    components: {
      BaseModal,
      TrunksInputSelectTrunk
    },

    data() {
      return {
        form: {
          trunk_id: null,
          date: initSearchStateByPeriod()
        },
        options: 2592000000 // 30 day
      }
    },

    methods: {
      getFormData() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);

        const params = {
          date_from: start,
          date_to: end
        };

        return params;
      },
      exportRequest() {
        const params = this.getFormData();
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            ExportService.getFiles(params)
              .then(() => {
                this.$noty.success(this.$t('shared.component.noty.export_pbx'));
              })
              .catch(error => this.$noty.server_error(error));
          }
        })
        this.$refs.close.$el.click()
      }
    }
  };
</script>

<style lang="scss">
  .pr-25 {
    padding-right: 25px !important;
  }

  .z-form-item {
    .main-ip__tooltip {
      .ivu-tooltip {
        position: absolute;
        top: 5px;
        right: -26px;

        &-popper {
          left: -130px !important;
        }

        &-arrow {
          left: 141px !important;
        }

        &-inner {
          width: 150px;
        }

        i {
          font-size: 21px;
        }
      }
    }
  }
</style>
